var app = {
	header: {
		build: "Build",
		closeButton: "Fermer",
		copyrightLabel: "Copyright",
		helpLabel: "Aide",
		legalNoticeLabel: "Mentions légales",
		logoutButton: "Déconnexion",
		menuLabel: "Menu",
		module: "Module",
		myData: "Mes données",
		noUserDataLabel: "Aucune donnée utilisateur disponible",
		notificationsLabel: "Notifications",
		privacyPolicyLabel: "Politique de confidentialité",
		search: "Rechercher",
		searchPlaceholder: "Rechercher un terme ou une question",
		serviceAppLabel: "Service-App",
		settingsLabel: "Paramètres",
		shopLabel: "Shop",
		smartFactorySuiteLabel: "Smart-Factory Suite",
		softwareInformation: "Informations sur le logiciel",
		toMytrumpf: "À MyTRUMPF",
		toTrumpfCom: "À trumpf.com",
		userLabel: "Profil",
		userProfileLinkText: "Profil utilisateur",
		version: "Version"
	}
};
var contentLoadingError = "Impossible de charger le contenu";
var dashboard = {
	cancel: {
		button: "Annuler"
	},
	edit: {
		button: "Modifier"
	},
	reset: {
		button: "Réinitialiser"
	},
	save: {
		button: "Enregistrer"
	},
	share: {
		button: "Partager"
	}
};
var fileUpload = {
	invalidFileType: "Le fichier est du mauvais type",
	maxFileSize: "Le fichier est plus grand que la taille autorisée (max. {{maxSizeInMb}} MB)",
	maxFilesReached: "Nombre maximum de fichiers atteint"
};
var filter = {
	clear: "Retirer les filtres",
	clearAll: "Retirer tou les filtres"
};
var general = {
	nextButton: "Suivant",
	prevButton: "Précédent",
	resetButton: "Réinitialiser"
};
var locationMap = {
	locationLink: {
		label: "Va à l'endroit"
	}
};
var machineDiscontinuation = {
	linkText: "En savoir plus"
};
var notifications = {
	button: {
		loadMore: "Charger plus"
	},
	date: {
		lastMonth: "Le mois dernier",
		lastWeek: "La semaine dernière",
		older: "Plus ancien",
		thisMonth: "Ce mois-ci",
		thisWeek: "Cette semaine",
		today: "Aujourd'hui",
		yesterday: "Hier"
	},
	error: {
		general: "Actuellement, aucune notification ne peut être affichée. Veuillez réessayer plus tard.",
		unauthorized: "Veuillez vous connecter pour voir les notifications"
	},
	info: {
		activateSettings: "Pour recevoir des notifications, veuillez les activer dans les paramètres",
		noNotification: "Il n'y a actuellement aucun message pour vous."
	},
	title: "Notifications"
};
var results = {
	counter: {
		label: "résultats"
	}
};
var scrollToTop = {
	label: "Remonter en haut"
};
var slider = {
	nextButton: {
		label: "Diapositive suivante"
	},
	paginationBullet: {
		label: "Diapositive"
	},
	prevButton: {
		label: "Diapositive précédente"
	}
};
var sorting = {
	ascending: "Ascendant",
	descending: "Descendant"
};
var userAccount = {
	address: {
		label: "Adresse postale"
	},
	email: {
		label: "E-mail"
	},
	language: {
		label: "Langue",
		locale: "Locale",
		select: "Sélectionner la langue",
		settings: "Paramètres de langue"
	},
	loggedOut: {
		message: "Vous n'êtes pas connecté"
	},
	login: {
		button: "Connexion"
	},
	name: {
		label: "Nom"
	},
	phone: {
		label: "Téléphone"
	}
};
var widget = {
	filter: {
		machine: {
			filter: "Filtrer les machines",
			label: "Machines",
			option: {
				all: "Toutes les machines"
			},
			select: "Sélectionner l'ordinateur"
		},
		period: {
			label: "Période",
			option: {
				currentMonth: "Ce mois-ci",
				currentWeek: "Cette semaine",
				lastMonth: "Le mois dernier",
				lastWeek: "La semaine dernière",
				today: "Aujourd'hui",
				yesterday: "Hier"
			}
		}
	}
};
var widgetRegistry = {
	allWidgets: {
		label: "Mes widgets"
	},
	noDescriptionAvailable: "Pas de description disponible.",
	widget: {
		SampleMyMachines: {
			title: "Mes Machines"
		},
		SampleMyServiceCalls: {
			title: "Appels de service"
		},
		SampleMyTrackingList: {
			title: "Liste de suivi"
		},
		SampleMyUserAccount: {
			title: "Mon profil"
		},
		SampleOperationalStatesChart: {
			title: "États opérationnels"
		},
		SampleWidgetFilter: {
			title: "Paramètres de filtre"
		},
		SampleWorkloadBalanceChart: {
			title: "Équilibre de la charge de travail"
		}
	}
};
var translation = {
	app: app,
	contentLoadingError: contentLoadingError,
	dashboard: dashboard,
	fileUpload: fileUpload,
	filter: filter,
	general: general,
	locationMap: locationMap,
	machineDiscontinuation: machineDiscontinuation,
	notifications: notifications,
	results: results,
	scrollToTop: scrollToTop,
	slider: slider,
	sorting: sorting,
	userAccount: userAccount,
	widget: widget,
	widgetRegistry: widgetRegistry
};

export { app, contentLoadingError, dashboard, translation as default, fileUpload, filter, general, locationMap, machineDiscontinuation, notifications, results, scrollToTop, slider, sorting, userAccount, widget, widgetRegistry };
